import { PERMISOS, PERMISOS_ADMIN, VER_SOLICITUDES } from "@/lib/permisos";

/**
 * Catálogo declarativo de comandos del Ctrl+K. Cada uno con label,
 * href, permisos (opcional · sin = todos) y keywords (opcional · ayudan
 * al search libre). El gateo es por PERMISO (RBAC · Ruta B), igual que el nav.
 *
 * Mantener este archivo como la única fuente de comandos · el filtro
 * y el render solo iteran. Para añadir un comando nuevo: agrega aquí
 * y listo, no toques el componente.
 */
export interface Comando {
  id: string;
  label: string;
  descripcion?: string;
  href: string;
  permisos?: ReadonlyArray<string>;
  keywords?: string;
}

export const COMANDOS: ReadonlyArray<Comando> = [
  { id: "dash", label: "Dashboard", href: "/dashboard", keywords: "inicio principal" },
  {
    id: "mis-sol",
    label: "Mis solicitudes de pago",
    href: "/solicitudes",
    permisos: VER_SOLICITUDES,
    keywords: "bandeja crear",
  },
  {
    id: "nueva",
    label: "+ Nueva solicitud",
    href: "/solicitudes/nueva",
    permisos: [PERMISOS.solicitudesGestionar],
    keywords: "crear iniciar fb60",
  },
  {
    id: "autoriz",
    label: "Bandeja de autorización",
    href: "/autorizacion/bandeja",
    permisos: [PERMISOS.autorizacionAutorizar],
    keywords: "autorizar pendientes",
  },
  {
    id: "contrapagos-pendientes",
    label: "Contrapagos pendientes",
    href: "/contrapagos-pendientes",
    permisos: [PERMISOS.contrapagosGestionar],
    keywords: "contrapago espera cfdi conciliar",
  },
  {
    id: "admin",
    label: "Panel de administración",
    href: "/admin",
    permisos: PERMISOS_ADMIN,
    keywords: "admin catalogos",
  },
  {
    id: "admin-org",
    label: "Admin · Organizaciones",
    href: "/admin/organizaciones",
    permisos: [PERMISOS.adminOrganizaciones],
    keywords: "sociedades rfc",
  },
  {
    id: "admin-prov",
    label: "Admin · Proveedores",
    href: "/admin/proveedores",
    permisos: [PERMISOS.adminProveedores],
    keywords: "proveedor rfc cuenta",
  },
  {
    id: "admin-area",
    label: "Admin · Áreas",
    href: "/admin/areas",
    permisos: [PERMISOS.adminAreas],
  },
  {
    id: "admin-usr",
    label: "Admin · Usuarios",
    href: "/admin/usuarios",
    permisos: [PERMISOS.adminUsuarios],
    keywords: "roles permisos",
  },
  {
    id: "admin-niv",
    label: "Admin · Flujos de autorización",
    href: "/admin/flujos-autorizacion",
    permisos: [PERMISOS.adminFlujosAutorizacion],
    keywords: "flujo niveles",
  },
  {
    id: "admin-cont",
    label: "Admin · Catálogos contables",
    href: "/admin/catalogos-contables",
    permisos: [PERMISOS.adminCatalogosContables],
    keywords: "ceco cuentas",
  },
  {
    id: "admin-sat",
    label: "Admin · Catálogos SAT",
    href: "/admin/catalogos-sat",
    permisos: [PERMISOS.adminCatalogosSat],
    keywords: "claves productos",
  },
  {
    id: "auditoria",
    label: "Auditoría",
    href: "/admin/auditoria",
    permisos: [PERMISOS.auditoriaVer],
    keywords: "log eventos accesos",
  },
];
